import type { NextRequest } from 'next/server';

/**
 * Derive the origin from the request's Host header so the URL matches the
 * domain the browser actually used.  Next.js dev server sets request.url to
 * its bound address (e.g. localhost:3000) regardless of the Host header, which
 * breaks cross-subdomain flows (e.g. PKCE on student.localhost:3000).
 */
export const getRequestOrigin = (request: NextRequest): string => {
  const requestUrl = new URL(request.url);
  const host = request.headers.get('host') || requestUrl.host;
  const proto = (request.headers.get('x-forwarded-proto') || requestUrl.protocol.slice(0, -1)).split(',')[0].trim();
  return `${proto}://${host}`;
};
